import { useEffect } from 'react'
import { useCountUp } from 'react-countup'

const ImpactStat = props => {
  const { number, title = '', visible } = props

  const hasDecimals = number % 1 > 0
  const aboutMoney = title.toLowerCase().includes('dollar')

  const { countUp, reset, start } = useCountUp({
    end: number,
    delay: 250,
    decimals: hasDecimals ? 1 : 0,
    decimal: '.'
  })

  useEffect(() => {
    reset()
    start()
  }, [visible])

  return (
    <div key={`${number} + ${title}`} className='col-12 col-md-6 col-lg-3 stat'>
      <div className='number'>
        {visible && (
          <div className='countup'>{(aboutMoney ? '$' : '') + countUp}</div>
        )}
      </div>
      <hr className='shortline-blue' />
      <div
        className='job-title'
        dangerouslySetInnerHTML={{
          __html: title
        }}
      ></div>
    </div>
  )
}

export default ImpactStat
